export const ANCESTRAL_ARCHIVE_LIST = 'ANCESTRAL_ARCHIVE_LIST'
export const ANCESTRAL_ARCHIVE_LIST_SUCCESS = 'ANCESTRAL_ARCHIVE_LIST_SUCCESS'

export const ANCESTRAL_ARCHIVE_DETAIL = 'ANCESTRAL_ARCHIVE_DETAIL'
export const ANCESTRAL_ARCHIVE_DETAIL_SUCCESS =
  'ANCESTRAL_ARCHIVE_DETAIL_SUCCESS'

export const ANCESTRAL_ARCHIVE_UPDATE = 'ANCESTRAL_ARCHIVE_UPDATE'
